import { Box, Typography } from "@mui/material";
import { Fake } from "components/layout/skeleton/Fake";

export const PendingLeaderboardSkeleton = () => {
    return (
        <Box
            component="ul"
            className="skeleton"
            sx={{
                p: 2,
                m: 0,
                listStyle: "none",
                display: "flex",
                flexDirection: "column",
                gap: 2,
            }}
        >
            <header>
                <Typography component="div" variant="label2">
                    <Fake size={23} />
                </Typography>
            </header>

            <Typography variant="body1" component="li">
                <Fake size={38} />
            </Typography>
            <Typography variant="body1" component="li">
                <Fake size={43} />
            </Typography>
            <Typography variant="body1" component="li">
                <Fake size={52} />
            </Typography>
            <Typography variant="body1" component="li">
                <Fake size={36} />
            </Typography>
        </Box>
    );
};
